var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"skeletonSwiper"}},[_c('div',{staticClass:"swiper-bg"},[_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((8),function(i){return _c('Skeleton',{key:i,staticClass:"swiper-slide"})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }